import { render, staticRenderFns } from "./carpsalePreviewPage.vue?vue&type=template&id=6081c37c&"
import script from "./carpsalePreviewPage.vue?vue&type=script&lang=ts&"
export * from "./carpsalePreviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports